import { analysis, analysisNames, IAnalysisResult } from "./analysisHelper";

enum EndCapStyle {
    Round = 1,
    Flat = 2,
    Square = 3,
}

interface IBufferOptions {
    Distance: number;
    QuadrantSegments: number;
    EndCapStyle: EndCapStyle;
}

const buffer = (oldLayerName: string, options: IBufferOptions, newLayerName: string, ) => {
    if (!oldLayerName) {
        window.pWarn('参数 oldLayerName 不能为空！');
        return;
    }
    if (!options.Distance || options.Distance < 0) {
        window.pWarn('参数 options.Distance 不合法！');
        return;
    }
    if (options.QuadrantSegments && options.QuadrantSegments < 1) {
        window.pWarn('参数 options.QuadrantSegments 不合法！');
        return;
    } else {
        options.QuadrantSegments = 8;
    }
    if (!options.EndCapStyle) {
        options.EndCapStyle = EndCapStyle.Round;
    }

    let analysisName = analysisNames.buffer;
    if (!newLayerName) {
        newLayerName = oldLayerName + "_" + analysisName;
    }
    analysis(oldLayerName, newLayerName, analysisName, options, (result) => {
        console.log("analysis result " + JSON.stringify(result));
        //window.VGIS.vMap.addGeoJson(result.GeoJson, newLayerName);
    });
}

//将buffer分析注入到vMap中
//window.VGIS.vMap.registerAnalysis(analysisNames.buffer, buffer);

export default buffer;